/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import styled from 'styled-components';
import logo from '../../img/logo.svg';
import Individual from './individual/Individual';
import Invitation from './invitation/Invitation';
import Professional from './professional/Professional';
import { resetStore } from './signupActions';

const CustomTab = styled(Tab)`
  font-size: 0.8em;
  min-width: 20px;
`;

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(5),
    flexGrow: 1,
    padding: '20px 40px 40px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

/* eslint-disable import/no-mutable-exports */
let Signup = ({ dispatchResetStore }) => {
  const [currentTable, setCurrentTable] = useState(0);

  function handleChange(event, newValue) {
    setCurrentTable(newValue);
    dispatchResetStore();
  }
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper className={classes.paper}>
        <img
          src={logo}
          alt="Logo sympl"
          width="230"
          style={{ marginBottom: 20 }}
        />
        <Tabs
          value={currentTable}
          onChange={handleChange}
          indicatorColor="primary"
        >
          <CustomTab label="Particulier" />
          <CustomTab label="Professionnel" />
          <CustomTab label="Collaborateur" />
        </Tabs>
        {currentTable === 0 && <Individual />}
        {currentTable === 1 && <Professional />}
        {currentTable === 2 && <Invitation />}
      </Paper>
    </Container>
  );
};

const mapDispatchToprops = dispatch => ({
  dispatchResetStore: () => dispatch(resetStore())
});

Signup = reduxForm({
  form: 'loginForm'
})(Signup);

Signup.propTypes = {
  dispatchResetStore: PropTypes.func.isRequired
};

export default withRouter(connect(null, mapDispatchToprops)(Signup));
